import { esTranslations as translations } from "../translations/es"; // Fixed import

export const translate = (key, fallback) => {
  return translations[key] || fallback;
};
